export async function compressImage(file: File, maxSize = 1500, quality = 0.85): Promise<File> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const { width, height } = img;
      let newW = width;
      let newH = height;
      if (Math.max(width, height) > maxSize) {
        const ratio = maxSize / Math.max(width, height);
        newW = Math.round(width * ratio);
        newH = Math.round(height * ratio);
      }
      const canvas = document.createElement('canvas');
      canvas.width = newW;
      canvas.height = newH;
      canvas.getContext('2d')!.drawImage(img, 0, 0, newW, newH);
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            reject(new Error('Compression failed'));
          } else {
            resolve(new File([blob], file.name.replace(/\.[^.]+$/, '.jpg'), { type: 'image/jpeg' }));
          }
        },
        'image/jpeg',
        quality,
      );
      URL.revokeObjectURL(img.src);
    };
    img.onerror = reject;
    img.src = URL.createObjectURL(file);
  });
}
